import { PlanningState, PlanningContext, ActionCandidate, AIActionType, IActionGenerator, IEvaluator } from "@/core/battle/ai/types/ai.types";
import { BattleUnit } from "@/core/types/battle.types";
import { getHexDistance, hasLineOfSight } from "@/core/utils/hex.utils";

export class AttackActionGenerator implements IActionGenerator {
    // constructor(private evaluator: AttackEvaluator) {}
    public generatorType: AIActionType = AIActionType.Attack;

    public generate(state: PlanningState, ctx: PlanningContext, evaluator: IEvaluator<BattleUnit>): ActionCandidate[] {
        const candidates: ActionCandidate[] = [];
        // 1. Найти всех врагов в радиусе атаки
        // 2. Для каждого посчитать utility через evaluator
        // 3. Вернуть объекты действий
        
        for (const target of ctx.enemies) {
            const distance = getHexDistance(state.position, target);
            for (const skill of ctx.unit.skills) {
                // 1. Швидка перевірка: чи в радіусі? (Геометрія)
                if (distance > skill.range) continue;

                // 2. Швидка перевірка: чи вистачає стаміни?
                const skillCost = skill.cost;
                if (state.stamina < skillCost) continue;

                // 3. Розумна перевірка Line of Sight (LOS)
                // Перевіряємо тільки якщо дистанція > 1 (дальній бій)
                // Впритул (distance === 1) вважаємо, що юніти бачать один одного завжди
                if (distance > 1) {
                    // Тут ми передаємо battleMap, який має бути в ctx або доступний через store
                    if (!hasLineOfSight(state.position, { q: target.q, r: target.r }, ctx.battleMap)) {
                        continue; // Ціль за стіною/іншим юнітом — пропускаємо цей варіант
                    }
                }
                const evalResult = evaluator.evaluate(state, ctx, target, skill);

                candidates.push({
                    action: {
                        type: AIActionType.Attack,
                        unitId: ctx.unit.unitId,
                        targetUnitId: target.unitId,
                        skillId: skill.id,
                        utility: evalResult.utility
                    },
                    utility: evalResult.utility,
                    staminaAfter: state.stamina - skillCost,
                    position: state.position,
                    components: evalResult.components,
                    metadata: {
                        type: 'attack',
                        targetEnemy: target.unitId,
                    },
                });
            }
        }
        return candidates;
    }
}